export const googleform = [
    {
        // データサイエンティスト育成講座 オンライン説明会
        tag: "school_introduction",
        name: "データミックス スクール無料説明会※オンライン",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSdpMOQi15wuZDaIvNWwnNFK-ouFFG9XGKur9vrklf6OL_sSCg/viewform?embedded=true",
        width: "100%",
        height: "1800",
    },
    {
        // 気象データアナリスト養成講座 オンライン説明会
        tag: "weather_da_introduction",
        name: "気象データアナリスト養成講座　無料説明会　※オンライン",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSfzHIcaeTwsfEq-7r8YY3Z_T9PAc7hDHor6ycSjWnVXdNwWew/viewform?embedded=true",
        width: "100%",
        height: "1800",
    },
    {
        // HRアナリスト養成講座 オンライン説明会
        tag: "hr_da_introduction",
        name: "HRアナリスト養成講座　無料説明会　※オンライン",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSdwTJu462rPdM9a5LigKN2nHZ84rPs8vdW4TMf4Tlh30DksNQ/viewform?embedded=true",
        width: "100%",
        height: "1800",
    },
    {
        // プロダクトデータアナリスト育成講座 オンライン説明会
        tag: "product_da_introduction",
        name: "プロダクト・データアナリスト育成講座　無料説明会　※オンライン",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSfm3gbOi5VlC0LfQaf-P8nC1nff0hjidd8b-L7UpaPYsFe_-A/viewform?embedded=true",
        width: "100%",
        height: "1800",
    },
    {
        // 生成AI・機械学習エンジニア育成講座説明会 オンライン説明会
        tag: "de_mle_introduction",
        name: "生成AI・機械学習エンジニア育成講座説明会　無料説明会　※オンライン",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSe3jObqk4QDAS99bSvnn0D0PM2lX7F_6ObYFE4dTQgjQw98AQ/viewform?embedded=true",
        width: "100%",
        height: "2500",
    },
    {
        // データエンジニア育成講座説明会 オンライン説明会
        tag: "de_introduction",
        name: "データエンジニア育成講座　無料説明会　※オンライン",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSfnGicsZcnrVX4P_PyREN_6SMYcxq2eqLDQ2XCK1q9qwu6Zmw/viewform?embedded=true",
        width: "100%",
        height: "1800",
    },
    {
        // 経営変革アナリスト育成講座 オンライン説明会
        tag: "bta_introduction",
        name: "経営変革アナリスト育成講座　無料説明会　※オンライン",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLScPY0SUr_SeiFXJKw8I2F4sLEXadthg7Ts1OSs1OyLfCI6vTw/viewform?embedded=true",
        width: "100%",
        height: "1800",
    },
    {
        // データサイエンティスト育成講座 無料体験講座
        tag: "ikusei-trial-lesson",
        name: "データサイエンティスト育成講座　無料体験講座/説明会　※オンライン",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSe2T_a6k-3tHQ1JcyVHLCnU9awudLzJg89MryW7v1sAKtAIJg/viewform?embedded=true",
        width: "100%",
        height: "1800",
    },
    {
        // ゼロから学ぶPythonプログラミング WS
        tag: "python_program",
        name: "【無料】ゼロから学ぶPythonプログラミング※オンライン",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSd2TkN6CL7A7Dli2byMRXOidZfR1hgZzireSOlV1sf_EhEL-Q/viewform?embedded=true",
        width: "100%",
        height: "1800",
    },
    {
        // オープンキャンパス
        tag: "open-school",
        name: "【無料イベント】データミックス オープンキャンパス",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSd1xdCCvCpF9rqizZ6aTwvZbreYv0ZMME5LkDE2xIe5gPSHag/viewform?embedded=true",
        width: "100%",
        height: "1800",
    },
    {
        // 「営業」と「データサイエンス」 の融合が、営業組織をリードするビジネスリーダーになる鍵 セミナー
        tag: "online-event-sales",
        name: "【無料イベント】「営業」と「データサイエンス」 の融合が、営業組織をリードするビジネスリーダーになる鍵 ※オンライン",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSd3PP1a2Y8ajbhvE8uqmpk_DSCqeDmw1Aq9_BeywYRE0BVgDg/viewform?embedded=true",
        width: "100%",
        height: "2000",
    },
    // {
    //     // データミックス卒業生が語る 「データサイエンス学習後の実務・キャリアへの活かし方」 セミナー
    //     tag: "ikusei_zadankai-grad",
    //     name: "【無料イベント】データミックス卒業生が語る 「データサイエンス学習後の実務・キャリアへの活かし方」",
    //     price: 0,
    //     url: "https://docs.google.com/forms/d/e/1FAIpQLScEkk10ZkeZ0TIH_b4NGcNefLwB_meM8cvmP5N6R0U_JJgP-Q/viewform?embedded=true",
    //     width: "100%",
    //     height: "2000",
    // },
    {
        // データサイエンス人材の転職・副業の “今” セミナー
        tag: "online-event-career",
        name: "【無料イベント】データサイエンス人材の転職・副業の “今”　※オンライン",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSewz2jegWvMsGCEjtnOVJHt-2N9SDBHq9tDbDMkuWoPjxJ0Zw/viewform?embedded=true",
        width: "100%",
        height: "2000",
    },
    {
        // 生成AI時代に「選ばれる人」になる — 市場価値を高めるAI・データ活用スキルとは？ セミナー
        tag: "online-event-reskill",
        name: "生成AI時代に「選ばれる人」になる — 市場価値を高めるAI・データ活用スキルとは？",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSdk4rnXJi6IJBoAEngy3qmLlwMqdo9ryqFXXkmaoYQYf8vdZg/viewform?embedded=true",
        width: "100%",
        height: "2000",
    },
    {
        // 進化するスポーツDXの世界「スポーツアナリティクスとは」 セミナー
        tag: "online-event-sports",
        name: "【無料イベント】進化するスポーツDXの世界「スポーツアナリティクスとは」",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSeCAV55Jmtoc6BYTzcxLaXdtIsPWnxORPLDnor-Nmpy_699dw/viewform?embedded=true",
        width: "100%",
        height: "2000",
    },
    {
        // AI時代到来でデータサイエンティストの役割は終わりか、それとも始まりか？ セミナー
        tag: "online-event-datascientist",
        name: "【無料イベント】AI時代到来でデータサイエンティストの役割は終わりか、それとも始まりか？",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLScM4-jSVucCytwUpBjK_r_QszWN3wBsKNlHX8Bw38dF97IMrQ/viewform?embedded=true",
        width: "100%",
        height: "1800",
    },
    {
        // スクール無料個別受講相談会
        tag: "ikusei-session",
        name: "スクール無料個別受講相談会　※オンライン",
        price: 0,
        type: "calendar",
        url: "https://calendar.google.com/appointments/schedules/AcZssZ3JjDD-nGdfEKX7kxMxK0MU--B3pOl_qOKX7sENVFgSEj-nexFoEr7Gtjgp9rqF_XdU4olgsMYC?gv=true",
        width: "100%",
        height: "1000",
    },
    {
        // 中学数学から始める生成AIの仕組み セミナー
        tag: "online-event-genai-intro",
        name: "【無料イベント】中学数学から始める生成AIの仕組み",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLScmhnnG55PyN3yMme8rN_tkH4b62BcEH3AX7R8sU3E_aVF3lw/viewform?embedded=true",
        width: "100%",
        height: "1800",
    },
    {
        // AI・データサイエンスは独学で身につくのか？ セミナー
        tag: "online-event-self-learning",
        name: "【無料イベント】AI・データサイエンスは独学で身につくのか？",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSdyEXjRBK9proMZRlJbddAzCnE5JYQipxmdk8AJq3wkhubbqQ/viewform?embedded=true",
        width: "100%",
        height: "1800",
    },
    {
        // ChatGPT活用！最短ルートで学ぶ機械学習入門 セミナー
        tag: "online-event-chatgpt-ml",
        name: "【無料イベント】ChatGPT活用！最短ルートで学ぶ機械学習入門",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSezttpdniQX-HdWkHTgNVs76e5m8DANfpxjryeO9ZmzHTlsTA/viewform?embedded=true",
        width: "100%",
        height: "1800",
    },
    {
        // 生成AIを使って1時間でデータ分析コンペティションKaggleに挑戦！ セミナー
        tag: "online-event-chatgpt-kaggle",
        name: "【無料イベント】生成AIを使って1時間でデータ分析コンペティションKaggleに挑戦！",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSd0E6P5zKFZ-xXmqkoPjCWnVcRjUEF7ptDC0pjVQT0jKgv_ig/viewform?embedded=true",
        width: "100%",
        height: "1500",
    },
    {
        // 卒業生向け統合説明会
        tag: "graduatecourse_introduction",
        name: "データミックス　卒業生向け統合説明会※オンライン",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSdzuh3EjGKTLyE4ePsZqukCAhKpnEcc-6Kdkg_iO6u85R7xCA/viewform?embedded=true",
        width: "100%",
        height: "1500",
    },
    {
        // データサイエンスとAIで仕事をアップデートする　- 事例で理解するあなたが次に目指すキャリアとは-
        tag: "online-event-updateyourcareer",
        name: "データサイエンスとAIで仕事をアップデートする　- 事例で理解するあなたが次に目指すキャリアとは-",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSfBBHmhQnCQitNBdhrHgnDgthr7-3xGHFzyudMnn68fbmZMqQ/viewform?embedded=true",
        width: "100%",
        height: "1600",
    },
    {
        // Excelの次はこれ！ChatGPTと“ちょっとだけコード”で体験する、AI時代の分析スキル超入門
        tag: "online-event-MLBuild-ChatGPT",
        name: "Excelの次はこれ！ChatGPTと“ちょっとだけコード”で体験する、AI時代の分析スキル超入門",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSfXbjyY3K3REBEdfBdM2mfOyywdNVbgrGcJUuBsbmJUk-v-wA/viewform?embedded=true",
        width: "100%",
        height: "1600",
    },
    {
        // 40代からの挑戦：“挫折“から“起業“まで導いたデータサイエンス習得ストーリー
        tag: "ikusei_zadankai-grad",
        name: "40代からの挑戦：“挫折“から“起業“まで導いたデータサイエンス習得ストーリー",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSdXWdyhsj8RZ3X_734tE209-qdNDJP5MxNDWcw-XbilXvMqwA/viewform?embedded=true",
        width: "100%",
        height: "1700",
    },
        {
        // データミックス卒業生のリアルストーリー～NEXT CAREER～
        tag: "next_career",
        name: "データミックス卒業生のリアルストーリー～NEXT CAREER～",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLScmWLsT6lUP0huj6yjo-jw9mq_RwueLbUQbK_pzOW0b4VEPDQ/viewform?embedded=true",
        width: "100%",
        height: "2500",
    },
    {
        // データミックス卒業発表会
        tag: "grad_presentation",
        name: "データミックス卒業発表会",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSck35KgxmY_fukuP93l9DlRxZdUX8q4AmT1IY4Dk3N4WPUBPg/viewform?embedded=true",
        width: "100%",
        height: "3200",
    },
    // {
    //     // 【無料イベント】 「生成AIを“使う人”で終わらない」── AI専門家と考える、次の10年を切り拓くスキル
    //     tag: "gacco",
    //     name: "【無料イベント】 「生成AIを“使う人”で終わらない」── AI専門家と考える、次の10年を切り拓くスキル",
    //     price: 0,
    //     type: "form",
    //     url: "https://docs.google.com/forms/d/e/1FAIpQLSfmhhUa4pQl3a0gqU05d397Zq9fDxbhFKSfyi1YGLSFqdMI_Q/viewform?embedded=true",
    //     width: "100%",
    //     height: "3200",
    // },
    {
        // 【無料イベント】AIでアプリはどう作る？デモでザックリ理解するAIアプリ開発入門
        tag: "gacco",
        name: "【無料イベント】AIでアプリはどう作る？デモでザックリ理解するAIアプリ開発入門",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSddIbWEtaz2KJbgR1LmsLsHW6_hqnnPK1RGvLfK32ekdiQo5g/viewform?embedded=true",
        width: "100%",
        height: "3300",
    },
    {
        // 【無料イベント】“意思決定のスピードと精度”を両立する、データ活用のための分析思考
        tag: "analytical_thinking",
        name: "【無料イベント】“意思決定のスピードと精度”を両立する、データ活用のための分析思考",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSfq8P6tHfDsRDYmbvhazv7USB14MLax9XI-zAvSrYEyA2bZTg/viewform?embedded=true",
        width: "100%",
        height: "3200",
    },
    {
        // 【無料イベント】数学が苦手でも大丈夫！ 文系出身者のための「中学数学」で始めるデータサイエンス入門
        tag: "mathematics",
        name: "【無料イベント】数学が苦手でも大丈夫！ 文系出身者のための「中学数学」で始めるデータサイエンス入門",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSe1c1nI1y4hue8Rcjg4VcwMq6BW-xXMx1fqQl1gEG31SlbaRA/viewform?embedded=true",
        width: "100%",
        height: "3200",
    },
    {
        // 【無料イベント】「未経験からデータ分析を仕事にする」を現実に ― 卒業後のキャリアパスと実務経験の積み方
        tag: "work_experience",
        name: "【無料イベント】「未経験からデータ分析を仕事にする」を現実に ― 卒業後のキャリアパスと実務経験の積み方",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSdePPlihAo7InIURuke2IL_OoIvz-Apju4E3wBrijXMlwJT3A/viewform?embedded=true",
        width: "100%",
        height: "3200",
    },
    {
        // 【無料イベント】もう絶対に挫折しない！ データサイエンスを体系的に学ぶためのロードマップ
        tag: "road_map",
        name: "【無料イベント】もう絶対に挫折しない！ データサイエンスを体系的に学ぶためのロードマップ",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLScMl03abRxdasSiWjllbIY6yvffq_0AZq9eX5OF8zi956mWcQ/viewform?embedded=true",
        width: "100%",
        height: "3200",
    },
    {
        // 【無料イベント】生成AI時代だからこそ知っておきたいデータマネジメントの基礎
        tag: "data_management",
        name: "【無料イベント】生成AI時代だからこそ知っておきたいデータマネジメントの基礎",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSceyXALLFFLdXlKBerBIrWRbAIGBU6EvyTVD1-a61YrlYDQ1Q/viewform?embedded=true",
        width: "100%",
        height: "3200",
    },
    {
        // 【無料イベント】あなたの業務経験こそ「武器」になる - AIエージェント×Power Platform実践
        tag: "ai_agent",
        name: "【無料イベント】あなたの業務経験こそ「武器」になる - AIエージェント×Power Platform実践",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSdawYUWCJhLpI2sEDI77TmoEgWw9w9QHvodcF4VLkq2EQdBBg/viewform?embedded=true",
        width: "100%",
        height: "3200",
    },
    {
        // 【無料イベント】【普段ワード・エクセルしか使っていない方限定】1時間後、AIを使ってプログラミングできています
        tag: "ai_programming",
        name: "【無料イベント】【普段ワード・エクセルしか使っていない方限定】1時間後、AIを使ってプログラミングできています",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSembGq2DyH3efOtLR0xqkp1GDcTn3-FsKI5h5XCkwLSW4dOIA/viewform?embedded=true",
        width: "100%",
        height: "3200",
    },
    {
        // 【無料イベント】ベテランビジネスパーソンが語る「AI・データサイエンス学習奮闘記」と異業種からAI業界への転職のリアル
        tag: "ai_careerchange",
        name: "【無料イベント】ベテランビジネスパーソンが語る「AI・データサイエンス学習奮闘記」と異業種からAI業界への転職のリアル",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSctJy34mQsJ1fDjPnRoDlNtdF08GJnQJ62osIwPiF6T7vsBFg/viewform?embedded=true",
        width: "100%",
        height: "3200",
    },
    {
        // 【無料イベント】無料！15分で作れる！あなたの「数学苦手」に寄り添うAI家庭教師の作り方
        tag: "ai_tutor",
        name: "【無料イベント】無料！15分で作れる！あなたの「数学苦手」に寄り添うAI家庭教師の作り方",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSfdzXCxZlU__JYI2e8_rSHB1_Fu5tKcKkRiX0YlGRjeVNvIdQ/viewform?embedded=true",
        width: "100%",
        height: "3200",
    },
    {
        // 【無料イベント】数学・プログラミングが苦手でも大丈夫！プロンプト入力だけでAIにデータ分析を任せられる。AIエージェントで体感する「自分でコードを書かない」Pythonデータ分析Live
        tag: "data_live",
        name: "【無料イベント】数学・プログラミングが苦手でも大丈夫！プロンプト入力だけでAIにデータ分析を任せられる。AIエージェントで体感する「自分でコードを書かない」Pythonデータ分析Live",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSfGCAwljJznXXfzx6krTWlQAHMB5SdqKSOufWW7AQaXxFHC7g/viewform?embedded=true",
        width: "100%",
        height: "3200",
    },
    {
        // 【無料イベント】40代のキャリアの壁は「これまでの経験×AI」で突破する。未経験からAI研修講師になった私のリアルな1年
        tag: "ai_instructor",
        name: "【無料イベント】40代のキャリアの壁は「これまでの経験×AI」で突破する。未経験からAI研修講師になった私のリアルな1年",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSeFcKto6BoJpmbcr3l_8O8lM6Pw0ELqmwCU-uBtDmt7qgOa9Q/viewform?embedded=true",
        width: "100%",
        height: "3200",
    },
    {
        // 【無料イベント】「AIの仮面を剥いでやる」の翻訳者と考える　「AI任せ」の時代に、私たちが考え、語る意味 
        tag: "gacco_aitalk",
        name: "【無料イベント】「AIの仮面を剥いでやる」の翻訳者と考える　「AI任せ」の時代に、私たちが考え、語る意味",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSeq29Ctt0NXljT-1P7rFtWsq2V_oZC3Kg4XsEl1UaUeHW5P9g/viewform?embedded=true",
        width: "100%",
        height: "3200",
    },
    {
        // 【無料イベント】「AIの仮面を剥いでやる」の翻訳者と考える　「AI任せ」の時代に、私たちが考え、語る意味 
        tag: "gacco_aitalk_mean",
        name: "【無料イベント】「AIの仮面を剥いでやる」の翻訳者と考える　「AI任せ」の時代に、私たちが考え、語る意味",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSfVZKKsR8BtsG2nernzuuZHY2X1xnJYa-33T4eODJiy1akFRQ/viewform?embedded=true",
        width: "100%",
        height: "3200",
    },
    {
        // 【無料イベント】【50代・60代の方限定】ベテランビジネスパーソンのAI・データサイエンスを武器にした実務・副業への挑戦
        tag: "sidejob_challenge",
        name: "【無料イベント】【50代・60代の方限定】ベテランビジネスパーソンのAI・データサイエンスを武器にした実務・副業への挑戦",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLScKLoCobninPN07vuUbQ99r4feHCtydvRRdhVbXiUQV3QecoQ/viewform?embedded=true",
        width: "100%",
        height: "3200",
    },
    {
        // 【オンデマンド配信】無料！15分で作れる！あなたの「数学苦手」に寄り添うAI家庭教師の作り方
        tag: "vod_ai_tutor",
        name: "【オンデマンド配信】無料！15分で作れる！あなたの「数学苦手」に寄り添うAI家庭教師の作り方",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSfBp2JO8u6DMmXxgEKY7dvgaEB3CK3wAvYVGo8TSkTgi65vgA/viewform?embedded=true",
        width: "100%",
        height: "5000",
    },
    {
        // 【オンデマンド配信】【普段ワード・エクセルし か使っていない方限定】1時間後、AIを使ってプログラミングできています  
        tag: "vod_ai_programming",
        name: "【オンデマンド配信】【普段ワード・エクセルしか使っていない方限定】1時間後、AIを使ってプログラミングできています",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSdBWvT5iPMchy4Z8US6VM3UXbv1bcpHm5qvPaF_lvHPbTH5Kg/viewform?embedded=true",
        width: "100%",
        height: "5000",
    },
    {
        // 【オンデマンド配信】数学が苦手でも大丈夫！文系出身者のための「中学数学」で始めるデータサイエンス入門  
        tag: "vod_mathematics",
        name: "【オンデマンド配信】数学が苦手でも大丈夫！文系出身者のための「中学数学」で始めるデータサイエンス入門",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSc8rk7YmGGjtg3LssuXh_mqxMfNSgvaCZHjRXaXtv-tiSB4fw/viewform?embedded=true",
        width: "100%",
        height: "5000",
    },
    {
        // 【オンデマンド配信】もう絶対に挫折しない！データサイエンスを体系的に学ぶためのロードマップ
        tag: "vod_road_map",
        name: "【オンデマンド配信】もう絶対に挫折しない！データサイエンスを体系的に学ぶためのロードマップ",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSc1TIQbQeCHkbbnXkOaLUAv7fEgBLlOzAxv6qplet8VlfftOg/viewform?embedded=true",
        width: "100%",
        height: "5000",
    },
    {
        // 【無料イベント】AIが書いた資料、あなたならどう直す？部下の"生成AI任せ"を成長に変えるフィードバック術
        tag: "free_ai_feedback",
        name: "【無料イベント】AIが書いた資料、あなたならどう直す？部下の\"生成AI任せ\"を成長に変えるフィードバック術",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLScgKeb5iMNZZC2DqFXARrz5mEp4tTG-JgdB8la-yTey-CYqDQ/viewform?embedded=true",
        width: "100%",
        height: "5000",
    },
    {
        // 【無料イベント】情報洪水に溺れない！データサイエンティストが教える AIトレンドの「大きな流れ」のつかみ方
        tag: "free_ai_trend",
        name: "【無料イベント】情報洪水に溺れない！データサイエンティストが教える AIトレンドの「大きな流れ」のつかみ方",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSfIbQddaCxrqapU397Qo4Z9x4U7-NwikX7cyJnT89nU9GrFXw/viewform?embedded=true",
        width: "100%",
        height: "5000",
    },
    {
        // 【無料イベント】新しい役割で成果を出す！ KPI設計とデータの語り方
        tag: "free_kpi_design",
        name: "【無料イベント】新しい役割で成果を出す！ KPI設計とデータの語り方",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSdbBdxyLh3yg30d61b_GjSJWJG0Nf79KdDGMj2a-o6td80NPA/viewform?embedded=true",
        width: "100%",
        height: "5000",
    },
    {
        // 【新講座説明会】AIを「使う」から「任せる」へ。あなたの思考を拡張する2週間、始まります
        tag: "free_ai_introduction",
        name: "【新講座説明会】AIを「使う」から「任せる」へ。あなたの思考を拡張する2週間、始まります",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSfEmcbhJPIMRgFpnS-3G8Rbui9zRG4LlxvLOg4BT12AnFuY5g/viewform?embedded=true",
        width: "100%",
        height: "5000",
    },
    {
        // 【無料イベント】未経験からデータサイエンティストへ ー 卒業生3名を採用した企業トップが語る「活躍する人の条件」
        tag: "free_success_conditions",
        name: "【無料イベント】未経験からデータサイエンティストへ ー 卒業生3名を採用した企業トップが語る「活躍する人の条件」",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSe6HJ5zGEGF3QVbp43QsnYme73hYc16IZHz4FN9Y4aoDMya3g/viewform?embedded=true",
        width: "100%",
        height: "5000",
    },
    {
        // 【無料イベント】5月病を乗り越える！ 組織の不調をデータで見つけるピープルアナリティクス入門
        tag: "free_mayblues",
        name: "【無料イベント】5月病を乗り越える！ 組織の不調をデータで見つけるピープルアナリティクス入門",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSd-fYjzVzCuPkeiNvHtH1QwcGEoOgwsXsuc21Tl3albjPrI1A/viewform?embedded=true",
        width: "100%",
        height: "5000",
    },
    {
        // 【オンデマンド配信】AIでアプリはどう作る？デモでザックリ理解するAIアプリ開発入門
        tag: "vod_gacco",
        name: "【オンデマンド配信】AIでアプリはどう作る？デモでザックリ理解するAIアプリ開発入門",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSd8IDWhA7QlsavRz5jdUTdExC38SINxTIRiUC52qfUfKKNxmA/viewform?embedded=true",
        width: "100%",
        height: "5000",
    },
    {
        // 【オンデマンド配信】数学・プログラミングが苦手でも大丈夫！プロンプト入力だけでAIにデータ分析を任せられる。AIエージェントで体感する「自分でコードを書かない」Pythonデータ分析Live
        tag: "vod_data_live",
        name: "【オンデマンド配信】数学・プログラミングが苦手でも大丈夫！プロンプト入力だけでAIにデータ分析を任せられる。AIエージェントで体感する「自分でコードを書かない」Pythonデータ分析Live",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSdiNcM3RC1sL0iCmrl9M9CE9sTrzKEthA7GD9axTTN6Lf4oWg/viewform?embedded=true",
        width: "100%",
        height: "5000",
    },
    {
        // 【オンデマンド配信】40代のキャリアの壁は「これまでの経験×AI」で突破する。未経験からAI研修講師になった私のリアルな1年
        tag: "vod_ai_instructor",
        name: "【オンデマンド配信】40代のキャリアの壁は「これまでの経験×AI」で突破する。未経験からAI研修講師になった私のリアルな1年",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSdDsGWVU1vM5D6Cyv-mnu0NM6oB3_WK2MuLEMBgcPAH9NqFyw/viewform?embedded=true",
        width: "100%",
        height: "5000",
    },
    {
        // 【無料イベント】W杯開幕直前！データ×戦術で読み解く日本代表の勝機と業界を問わず求められる『データサイエンティスト』の本質
        tag: "free_wc_data_tactics",
        name: "【無料イベント】W杯開幕直前！データ×戦術で読み解く日本代表の勝機と業界を問わず求められる『データサイエンティスト』の本質",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSc0YqBT-cOkqDZrLh40KQflyWb8TZwgmUZxIDLWRC6eWze89w/viewform?embedded=true",
        width: "100%",
        height: "5000",
    },
    {
        // 【無料イベント】憂鬱な梅雨、そして来る猛暑をデータサイエンスする - 気象データアナリストの仕事とリアル
        tag: "free_weatherdata",
        name: "【無料イベント】憂鬱な梅雨、そして来る猛暑をデータサイエンスする - 気象データアナリストの仕事とリアル",
        price: 0,
        type: "form",
        url: "https://docs.google.com/forms/d/e/1FAIpQLScP4ct4j8QvWtqGAmNoawRaAMz-db2GXpp3PrJhKAqr7ESWZQ/viewform?embedded=true",
        width: "100%",
        height: "5000",
    },
    // {
    //     // Memo
    //     tag: "",
    //     name: "",
    //     price: 0,
    //     type: "form",
    //     url: "",
    //     width: "100%",
    //     height: "3200",
    // },
    // // sample
    // {
    //     // sample
    //     tag: "sample",
    //     name: "サンプル",
    //     price: 0,
    //     type: "form",
    //     url: "https://docs.google.com/forms/d/e/1FAIpQLScze1ALr6J-nQberE_451bf-gR_hLBnTopxHnrfAiEoMfDbng/viewform?embedded=true",
    //     width: "100%",
    //     height: "1800",
    // },
    // {
    //     // sample
    //     tag: "sample-calendar",
    //     name: "サンプル-カレンダー",
    //     price: 0,
    //     type: "calendar",
    //     url: "https://calendar.google.com/calendar/appointments/schedules/AcZssZ0qL4YtDKU528BzpHcTg7iYqzh80bmFK2UfNpBwsuNm1qyPJk7FyGOW220d9Wf6QN37wuKGX9pv?gv=true",
    //     width: "100%",
    //     height: "1000",
    // },
]

export const salesformUrl = "https://go.datamix-school.com/l/1029621/2023-10-04/6j24";
